import { useQuery } from '@apollo/client/react';
import { GameCard } from '@optools/components/game-card';
import { GameSchedule } from '@optools/components/game-schedule';
import { PageLoader } from '@optools/components/loading/page-loader';
import { GET_LITMUS_VALIDATION_SCHEMAS } from '@optools/services/operator-gateway/media-validation/queries';
import { LitmusScheduleGame } from '@optools/services/operator-gateway/media-validation/types';
import { ReactNode } from 'react';

import { ValidationSuite } from './validation-suite';

export interface LitmusScheduleProps {
  children: ReactNode;
  loading: boolean;
  schedule: LitmusScheduleGame[] | undefined;
}

export function LitmusSchedule({ children, loading, schedule }: LitmusScheduleProps) {
  const { data, loading: schemasLoading } = useQuery(GET_LITMUS_VALIDATION_SCHEMAS);
  const validationSchemas = data?.validationSchemas ?? [];

  if (schemasLoading) {
    return <PageLoader />;
  }

  return (
    <GameSchedule
      data-testid="litmus-games-schedule"
      loading={loading}
      render={(game) => {
        return (
          <GameCard key={game.gamePk} data-testid={`game-${game.gamePk}`} game={game}>
            <ValidationSuite gamePk={game.gamePk} schemas={validationSchemas} />
          </GameCard>
        );
      }}
      schedule={schedule}>
      {children}
    </GameSchedule>
  );
}
